import React, { useEffect, useState } from "react";
import endpoint from "../../../auth/endpoint";
import { Link, Navigate } from "react-router-dom";
import Loader from "react-loader-advanced";
import "./printCustomCauseList.css";

const CauseListWithSisterCustomPrint = () => {
  const [isLoading, setLoading] = useState(false);
  const [dailyCauseList, setDailyCauseList] = useState({});
  const [date, setDate] = useState("");
  const [customAppealCauseList, setCustomAppealCauseList] = useState([]);
  const [customOtherCauseList, setCustomOtherCauseList] = useState([]);
  const [appealHeader, setAppealHeader] = useState(false);
  const [otherHeader, setOtherHeader] = useState(false);
  const [customAppealHeaderText, setCustomAppealHeaderText] = useState("");
  const [customOtherHeaderText, setCustomOtherHeaderText] = useState("");
  const [allLocations, setAllLocations] = useState([]);
  const [selectedCustomLocation, setSelectedCustomLocation] = useState("");
  // New state to track which location was selected for the header
  const [selectedAppealLocation, setSelectedAppealLocation] = useState("");
  const [selectedOtherLocation, setSelectedOtherLocation] = useState("");

  const dateSuffix = (day) => {
    if (day == 1 || day == 21 || day == 31) {
      return day + "" + "st";
    } else if (day == 2 || day == 22) {
      return day + "" + "nd";
    } else if (day == 3 || day == 23) {
      return day + "" + "rd";
    } else {
      return day + "" + "th";
    }
  };

  const formattedDate =
    date &&
    (
      new Date(date).toLocaleDateString("en-us", { weekday: "long" }) +
      ", " +
      dateSuffix(
        new Date(date).toLocaleDateString("en-us", { day: "numeric" }),
      ) +
      " day of " +
      new Date(date).toLocaleDateString("en-us", { month: "long" }) +
      ", " +
      new Date(date).toLocaleDateString("en-us", { year: "numeric" })
    ).toUpperCase();

  const curDate = new Date();
  const dateStr = (
    curDate.toLocaleDateString("en-us", { weekday: "long" }) +
    ", " +
    dateSuffix(curDate.toLocaleDateString("en-us", { day: "numeric" })) +
    " day of " +
    curDate.toLocaleDateString("en-us", { month: "long" }) +
    ", " +
    curDate.toLocaleDateString("en-us", { year: "numeric" })
  ).toUpperCase();

  const alphabetArray = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  const todaysDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");

    const formatDate = `${year}-${month}-${day}`;

    console.log("new", formatDate);
    return formatDate;
  };

  useEffect(() => {
    getDailyCauseList();
  }, []);

  const getDailyCauseList = async () => {
    setLoading(true);
    await endpoint
      .get(`/case-diary/new-day-list/${todaysDate()}`)
      .then(({ data }) => {
        console.log("response", data.data);
        let causeArr = data.data;

        const groupedByLocation = groupByLocationAndCaseType(causeArr);
        setDailyCauseList(groupedByLocation);

        const locations = Object.keys(groupedByLocation);
        setAllLocations(locations);

        if (locations.length > 0) {
          setSelectedCustomLocation(locations[0]);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const groupByLocationAndCaseType = (data) => {
    return data.reduce((result, obj) => {
      const location = obj.location || "UNKNOWN LOCATION";
      const caseTypeKey =
        obj.CaseType.case_type +
        " " +
        obj.CaseTypeCategory.case_type_cat +
        " " +
        (obj.AdjournmentType.id == 2 ? obj.AdjournmentType.id : "");

      if (!result[location]) {
        result[location] = {};
      }

      if (!result[location][caseTypeKey]) {
        result[location][caseTypeKey] = [];
      }

      result[location][caseTypeKey].push(obj);

      return result;
    }, {});
  };

  const handleFetchData = async () => {
    setLoading(true);
    await endpoint
      .get(`/case-diary/new-day-list/${date}`)
      .then(({ data }) => {
        console.log("response with supplied data", data.data);
        let causeArr = data.data;

        const groupedByLocation = groupByLocationAndCaseType(causeArr);
        setDailyCauseList(groupedByLocation);

        const locations = Object.keys(groupedByLocation);
        setAllLocations(locations);

        if (locations.length > 0) {
          setSelectedCustomLocation(locations[0]);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const splitHeading = (str) => {
    const firstSpaceIndex = str.indexOf(" ");
    const firstPart = str.slice(0, firstSpaceIndex);
    return (firstPart + " " + "Judgement").toUpperCase();
  };

  const removeNumber = (str) => {
    const result = str.replace(/[0-9]/g, "");
    return (result + " " + "(s)").toUpperCase();
  };

  // Updated to accept location parameter
  const customAppealHeader = (location) => {
    if (appealHeader == false) {
      setAppealHeader(true);
      setSelectedAppealLocation(location); // Store the location when header is checked
    } else {
      setAppealHeader(false);
      setCustomAppealCauseList([]);
      setCustomAppealHeaderText("");
      setSelectedAppealLocation(""); // Clear the location
    }
  };

  const customOtherHeader = (location) => {
    if (otherHeader == false) {
      setOtherHeader(true);
      setSelectedOtherLocation(location); // Store the location when header is checked
    } else {
      setOtherHeader(false);
      setCustomOtherCauseList([]);
      setCustomOtherHeaderText("");
      setSelectedOtherLocation(""); // Clear the location
    }
  };

  const checkedFnc = (e, Case, headings, location) => {
    console.log("headings", headings);
    console.log("location being added:", location);
    
    if (e.target.checked == true) {
      if (headings.includes("Appeal")) {
        if (!customAppealCauseList.some(item => item.case_id === Case.case_id)) {
          const caseWithLocation = { ...Case, location: location };
          setCustomAppealCauseList((prevList) => {
            console.log("Adding case to appeal list with location:", location);
            return [...prevList, caseWithLocation];
          });
        }
      } else {
        if (!customOtherCauseList.some(item => item.case_id === Case.case_id)) {
          const caseWithLocation = { ...Case, location: location };
          setCustomOtherCauseList((prevList) => {
            console.log("Adding case to other list with location:", location);
            return [...prevList, caseWithLocation];
          });
        }
      }
    }
    if (e.target.checked == false) {
      if (headings.includes("Appeal")) {
        setCustomAppealCauseList((prevList) =>
          prevList.filter((item) => item.case_id !== Case.case_id),
        );
      } else {
        setCustomOtherCauseList((prevList) =>
          prevList.filter((item) => item.case_id !== Case.case_id),
        );
      }
    }
  };

  const [isVisible, setIsVisible] = useState(true);
  const hideCauseList = () => {
    setIsVisible(!isVisible);
  };

  // Updated function to get location
  const getCustomLocation = () => {
    // For Appeal cases
    if (appealHeader) {
      // If there are cases in the list, get location from the most recent case
      if (customAppealCauseList.length > 0) {
        return customAppealCauseList[customAppealCauseList.length - 1]?.location || 
               customAppealCauseList[0]?.location || 
               selectedAppealLocation ||
               selectedCustomLocation || 
               "REGISTRY 1";
      }
      // If no cases yet, use the location from the header selection
      if (selectedAppealLocation) {
        return selectedAppealLocation;
      }
      return selectedCustomLocation || "REGISTRY 1";
    }
    
    // For Other cases
    if (otherHeader) {
      if (customOtherCauseList.length > 0) {
        return customOtherCauseList[customOtherCauseList.length - 1]?.location || 
               customOtherCauseList[0]?.location || 
               selectedOtherLocation ||
               selectedCustomLocation || 
               "REGISTRY 1";
      }
      if (selectedOtherLocation) {
        return selectedOtherLocation;
      }
      return selectedCustomLocation || "REGISTRY 1";
    }
    
    return selectedCustomLocation || "REGISTRY 1";
  };

  return (
    <>
      {isVisible && (
        <div id="divToPrint">
          <div className="row mt-4">
            <div className="col">
              <div className="input-group mb-3" id="hideDate">
                <input
                  type="date"
                  className="form-control"
                  aria-label="Recipient's username"
                  aria-describedby="button-addon2"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-outline-primary"
                    type="button"
                    onClick={handleFetchData}
                    id="button-addon2"
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
            <div className="col"></div>
          </div>

          {isLoading && <Loader />}

          {!isLoading && (
            <div className="row mt-4">
              <div className="col-md-12">
                {Object.entries(dailyCauseList).map(
                  ([location, caseTypes], locationIndex) => (
                    <div key={location} className="location-section mb-5">
                      <div className="row">
                        <div
                          className="col-md-12 text-center"
                          style={{
                            textDecoration: `underline`,
                            fontWeight: "bold",
                            fontSize: "18px",
                            marginBottom: "20px",
                          }}
                        >
                          <span>IN THE SUPREME COURT OF NIGERIA</span>
                          <br />
                          HOLDEN AT ABUJA <br />
                          CAUSE LIST FOR{" "}
                          {date ? formattedDate : dateStr.toUpperCase()} <br />
                          {location.toUpperCase()}
                        </div>
                      </div>

                      {Object.entries(caseTypes).map(
                        ([headings, items], caseTypeIndex) => (
                          <div
                            key={`${location}-${headings}`}
                            className="causeListHeading"
                          >
                            <div
                              className="text-center mb-2"
                              style={{
                                color: `${headings.toUpperCase().includes("CIVIL") ? "green" : headings.toUpperCase().includes("CRIMINAL") ? "red" : headings.toUpperCase().includes("POLITICAL") ? "blue" : ""}`,
                              }}
                            >
                              {`${alphabetArray[caseTypeIndex]}.` +
                                " " +
                                (headings.includes(2)
                                  ? splitHeading(headings)
                                  : removeNumber(headings))}
                            </div>
                            <div className="table-reponsive">
                              <table
                                className="table mb-5"
                                style={{ width: `100%` }}
                              >
                                <thead className="thead-light">
                                  <tr style={{ border: `1px solid black` }}>
                                    <th
                                      style={{
                                        maxWidth: `5px`,
                                        border: `1px solid black`,
                                      }}
                                    >
                                      {headings
                                        .toUpperCase()
                                        .includes("APPEAL") ? (
                                        <input
                                          type="checkbox"
                                          onClick={() => customAppealHeader(location)}
                                        />
                                      ) : (
                                        <input
                                          type="checkbox"
                                          onClick={() => customOtherHeader(location)}
                                        />
                                      )}
                                    </th>
                                    <th
                                      style={{
                                        maxWidth: `5px`,
                                        border: `1px solid black`,
                                      }}
                                    >
                                      SN.
                                    </th>
                                    <th
                                      scope="col"
                                      style={{ border: `1px solid black` }}
                                    >
                                      APPEAL NO.
                                    </th>
                                    {headings
                                      .toUpperCase()
                                      .includes("APPEAL") ? (
                                      <>
                                        <th
                                          scope="col"
                                          style={{ border: `1px solid black` }}
                                        >
                                          APPELLANTS
                                        </th>
                                        <th
                                          scope="col"
                                          style={{ border: `1px solid black` }}
                                        >
                                          RESPONDENTS
                                        </th>
                                      </>
                                    ) : (
                                      <>
                                        <th
                                          scope="col"
                                          style={{ border: `1px solid black` }}
                                        >
                                          PARTIES
                                        </th>
                                        <th
                                          scope="col"
                                          style={{ border: `1px solid black` }}
                                        >
                                          APPLICATIONS
                                        </th>
                                      </>
                                    )}
                                  </tr>
                                </thead>

                                <tbody>
                                  {items.map((item, index) => (
                                    <React.Fragment key={index}>
                                      {item.CaseAttachements &&
                                        item.CaseAttachements.map(
                                          (Case, index2) => (
                                            <tr
                                              key={`${index}-${index2}`}
                                              style={{
                                                border: `1px solid black`,
                                              }}
                                            >
                                              <td
                                                style={{
                                                  border: `1px solid black`,
                                                }}
                                              >
                                                <input
                                                  type="checkbox"
                                                  onClick={(e) =>
                                                    checkedFnc(
                                                      e,
                                                      Case,
                                                      headings,
                                                      item.location
                                                    )
                                                  }
                                                />
                                              </td>
                                              {index2 === 0 && (
                                                <td
                                                  rowSpan={
                                                    item.CaseAttachements.length
                                                  }
                                                  style={{
                                                    border: `1px solid black`,
                                                  }}
                                                >
                                                  {index + 1}.
                                                </td>
                                              )}
                                              <td
                                                style={{
                                                  border: `1px solid black`,
                                                  color: `${item.CaseType.case_color}`,
                                                }}
                                              >
                                                {Case.suite_no}
                                              </td>
                                              {headings
                                                .toUpperCase()
                                                .includes("APPEAL") ? (
                                                <>
                                                  <td
                                                    style={{
                                                      whiteSpace: `normal`,
                                                      border: `1px solid black`,
                                                    }}
                                                  >
                                                    <tr>{Case.appellants}</tr>
                                                    <tr>
                                                      {Case.appellants_title}
                                                    </tr>
                                                  </td>
                                                  <td
                                                    style={{
                                                      whiteSpace: `normal`,
                                                      border: `1px solid black`,
                                                    }}
                                                  >
                                                    <tr>{Case.respondent}</tr>
                                                    <tr>
                                                      {Case.respondent_title}
                                                    </tr>
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td
                                                    className="text-center"
                                                    style={{
                                                      whiteSpace: `normal`,
                                                      border: `1px solid black`,
                                                    }}
                                                  >
                                                    <tr>{Case.appellants}</tr>
                                                    <tr>
                                                      ({Case.appellants_title})
                                                    </tr>
                                                    <tr>
                                                      <div className="mt-2 mb-2">
                                                        VS.
                                                      </div>
                                                    </tr>
                                                    <tr>{Case.respondent}</tr>
                                                    <tr>
                                                      ({Case.respondent_title})
                                                    </tr>
                                                  </td>
                                                  <td
                                                    style={{
                                                      whiteSpace: `pre-wrap`,
                                                      border: `1px solid black`,
                                                      wordWrap: `break-word`,
                                                    }}
                                                  >
                                                    {Case.caseDescriptions &&
                                                    Case.caseDescriptions
                                                      .length > 0
                                                      ? Case.caseDescriptions.map(
                                                          (desc, i) => (
                                                            <p
                                                              key={i}
                                                              style={{
                                                                marginBottom:
                                                                  "10px",
                                                              }}
                                                            >
                                                              {i + 1}.{" "}
                                                              {desc.description}
                                                            </p>
                                                          ),
                                                        )
                                                      : "N/A"}
                                                  </td>
                                                </>
                                              )}
                                            </tr>
                                          ),
                                        )}
                                    </React.Fragment>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  ),
                )}
              </div>
            </div>
          )}

          <hr />
        </div>
      )}

      <div id="customCauseListPrint">
        {(appealHeader || otherHeader) && (
          <div className="row hideCustomHeader">
            <h5 className="text-center">CUSTOM CAUSELIST SECTION</h5>
          </div>
        )}

        <div>
          {appealHeader && (
            <div className="row mt-4">
              <div className="col-md-12">
                <div className="location-section mb-5">
                  <div className="row">
                    <div
                      className="col-md-12 text-center"
                      style={{
                        textDecoration: `underline`,
                        fontWeight: "bold",
                        fontSize: "18px",
                        marginBottom: "20px",
                      }}
                    >
                      <span>IN THE SUPREME COURT OF NIGERIA</span>
                      <br />
                      HOLDEN AT ABUJA <br />
                      CAUSE LIST FOR{" "}
                      {date ? formattedDate : dateStr.toUpperCase()} <br />
                      CUSTOM APPEAL LIST - {getCustomLocation().toUpperCase()}
                    </div>
                  </div>

                  <div className="causeListHeading">
                    <div className="text-center mb-2">
                      <div className="input-group mb-3 hideCustomInput">
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter custom header here"
                          defaultValue={customAppealHeaderText}
                          onChange={(e) =>
                            setCustomAppealHeaderText(e.target.value)
                          }
                        />
                      </div>
                      <div>
                        {customAppealHeaderText ? (
                          <div className="custom-header-text text-black">
                            {customAppealHeaderText}
                          </div>
                        ) : (
                          " "
                        )}
                      </div>
                    </div>
                    <div className="table-reponsive">
                      <table className="table mb-5" style={{ width: `100%` }}>
                        <thead className="thead-light">
                          <tr style={{ border: `1px solid black` }}>
                            <th
                              style={{
                                maxWidth: `5px`,
                                border: `1px solid black`,
                              }}
                            >
                              SN.
                            </th>
                            <th
                              scope="col"
                              style={{ border: `1px solid black` }}
                            >
                              APPEAL NO.
                            </th>
                            <th
                              scope="col"
                              style={{ border: `1px solid black` }}
                            >
                              APPELLANTS
                            </th>
                            <th
                              scope="col"
                              style={{ border: `1px solid black` }}
                            >
                              RESPONDENTS
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <>
                            {customAppealCauseList &&
                              customAppealCauseList.map((Case, index2) => (
                                <tr
                                  key={index2}
                                  style={{ border: `1px solid black` }}
                                >
                                  <td style={{ border: `1px solid black` }}>
                                    {index2 + 1}.
                                  </td>
                                  <td style={{ border: `1px solid black` }}>
                                    {Case.suite_no}
                                  </td>
                                  <>
                                    <td
                                      style={{
                                        whiteSpace: `normal`,
                                        border: `1px solid black`,
                                      }}
                                    >
                                      <tr>{Case.appellants}</tr>
                                      <tr>{Case.appellants_title}</tr>
                                    </td>
                                    <td
                                      style={{
                                        whiteSpace: `normal`,
                                        border: `1px solid black`,
                                      }}
                                    >
                                      <tr>{Case.respondent}</tr>
                                      <tr>{Case.respondent_title}</tr>
                                    </td>
                                  </>
                                </tr>
                              ))}
                          </>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {otherHeader && (
            <div className="row mt-4">
              <div className="col-md-12">
                <div className="location-section mb-5">
                  <div className="row">
                    <div
                      className="col-md-12 text-center"
                      style={{
                        textDecoration: `underline`,
                        fontWeight: "bold",
                        fontSize: "18px",
                        marginBottom: "20px",
                      }}
                    >
                      <span>IN THE SUPREME COURT OF NIGERIA</span>
                      <br />
                      HOLDEN AT ABUJA <br />
                      CAUSE LIST FOR{" "}
                      {date ? formattedDate : dateStr.toUpperCase()} <br />
                      {getCustomLocation().toUpperCase()}
                    </div>
                  </div>

                  <div className="causeListHeading">
                    <div className="text-center mb-2">
                      <div className="input-group mb-3 hideCustomInput">
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter custom header here"
                          defaultValue={customOtherHeaderText}
                          onChange={(e) =>
                            setCustomOtherHeaderText(e.target.value)
                          }
                        />
                      </div>
                      <div>
                        {customOtherHeaderText ? (
                          <div className="custom-header-text text-black">
                            {customOtherHeaderText}
                          </div>
                        ) : (
                          " "
                        )}
                      </div>
                    </div>
                    <div className="table-reponsive">
                      <table className="table mb-5" style={{ width: `100%` }}>
                        <thead className="thead-light">
                          <tr style={{ border: `1px solid black` }}>
                            <th
                              style={{
                                maxWidth: `5px`,
                                border: `1px solid black`,
                              }}
                            >
                              SN.
                            </th>
                            <th
                              scope="col"
                              style={{ border: `1px solid black` }}
                            >
                              APPEAL NO.
                            </th>
                            <th
                              scope="col"
                              style={{ border: `1px solid black` }}
                            >
                              PARTIES
                            </th>
                            <th
                              scope="col"
                              style={{ border: `1px solid black` }}
                            >
                              APPLICATIONS
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <>
                            {customOtherCauseList &&
                              customOtherCauseList.map((Case, index2) => (
                                <tr
                                  key={index2}
                                  style={{ border: `1px solid black` }}
                                >
                                  <td style={{ border: `1px solid black` }}>
                                    {index2 + 1}.
                                  </td>
                                  <td style={{ border: `1px solid black` }}>
                                    {Case.suite_no}
                                  </td>
                                  <td
                                    className="text-center"
                                    style={{
                                      whiteSpace: `normal`,
                                      border: `1px solid black`,
                                    }}
                                  >
                                    <tr>{Case.appellants}</tr>
                                    <tr>({Case.appellants_title}(s))</tr>
                                    <tr>
                                      <div className="mt-2 mb-2">VS.</div>
                                    </tr>
                                    <tr>{Case.respondent}</tr>
                                    <tr>({Case.respondent_title}(s))</tr>
                                  </td>
                                  <td
                                    style={{
                                      whiteSpace: `pre-wrap`,
                                      border: `1px solid black`,
                                      wordWrap: `break-word`,
                                    }}
                                  >
                                    {Case.caseDescriptions &&
                                    Case.caseDescriptions.length > 0
                                      ? Case.caseDescriptions.map((desc, i) => (
                                          <p
                                            key={i}
                                            style={{ marginBottom: "10px" }}
                                          >
                                            {i + 1}. {desc.description}
                                          </p>
                                        ))
                                      : "N/A"}
                                  </td>
                                </tr>
                              ))}
                          </>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {(appealHeader || otherHeader) && (
            <div className="col-md-12 hideCustomBtn">
              <p className="hideBtn">
                <i>
                  <span className="text-danger">***</span>Please click on Hide
                  Cause list before printing custom cause list
                  <span className="text-danger">***</span>
                </i>
              </p>
              {isVisible && (
                <button
                  className="btn btn-outline-primary hideBtn"
                  type="button"
                  onClick={() => {
                    hideCauseList();
                  }}
                  id="button-addon2"
                >
                  Hide Causelist
                </button>
              )}
              {!isVisible && (
                <button
                  className="btn btn-outline-primary hideBtn"
                  type="button"
                  onClick={() => {
                    hideCauseList();
                  }}
                  id="button-addon2"
                >
                  View Causelist
                </button>
              )}
              <button
                className="btn btn-outline-primary hideBtn"
                type="button"
                onClick={() => window.print()}
                id="button-addon2"
              >
                Print Custom Causelist
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CauseListWithSisterCustomPrint;